<div class="modal active">
  <div class="modal__container modal__container--lg" style="top: 5%;">
      <div class="fields">
          <h2>Potential Duplications Found</h2>
          <div class="close" (click)="bsModalRef.hide();"><img src="/assets/img/close-white.svg" alt="" /></div>
            <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
              <div class="fields__block">
                <div class="fields__block__section">
                  <div class="table-fields">
                    <h4> The following imported NavAids are potential duplications. Please check the working log file for more information. </h4>
                    <div class="table_container" style="height: 550px; overflow-y:auto;">
                        <table>
                            <thead>
                              <tr>
                                <th>ID</th>
                                <th>Name</th>
                                <th>Type</th>
                                <th>Icao CC</th>
                                <th>Published</th>
                                <th>Latitude</th>
                                <th>Longitude</th>
                                <th>VHF Frequency</th>
                                <th>Channel</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let navaid of duplicates; let i = index">
                                <td>{{navaid.navaidid}}</td>
                                <td>{{navaid.name}}</td>
                                <td>{{navaid.navaidtype}}</td>
                                <td>{{navaid.icaocc}}</td>
                                <td>{{navaid.Published}}</td>
                                <td>{{navaid.latitude}}</td>
                                <td>{{navaid.longitude}}</td>
                                <td>{{navaid.vhfTunFreqInput}}</td>
                                <td>{{navaid.channel}}</td>
                              </tr>
                            </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="fields__btn">
                <button (click)="bsModalRef.hide();" class="blue">Ok</button>
                <button (click)="exportNavaidsToCsv();" class="blue" >Export</button>
              </div>
            </div>
      </div>
    </div>
</div>
